module.exports = __webpack_public_path__ + "static/media/moto_3.296c6783.png";